import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {KeyboardTimePicker} from '@material-ui/pickers';
import '../DatePickerMUI/DatePickerMUI.scss';
import {ReactComponent as Time} from './time.svg';
import {TextField} from '@material-ui/core';
import {useTranslation} from 'react-i18next';

const TimePickerMUI = ({
  autoOk = true,
  clearable,
  disableFuture = false,
  disablePast = false,
  disableToolbar = false,
  disabled = false,
  emptyLabel = '',
  onChange,
  inputVariant = 'outlined',
  value = null,
  orientation = 'portrait',
  variant = 'dialog',
  views = ['hours', 'minutes']
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {t} = useTranslation();
  const handleOpen = () => !disabled && setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const TextFieldComponent = (props) => (
    <TextField
      onClick={handleOpen}
      {...props}
      InputProps={{
        ...props.InputProps,
        readOnly: true // Prevent direct input
      }}
    />
  );

  return (
    <KeyboardTimePicker
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      className={`date-picker-mui`}
      placeholder='__.__'
      mask='__.__'
      format='HH:mm'
      ampm={false}
      label={t('TimePickerMUI.label')}
      value={value}
      onChange={(date) => onChange(date)}
      orientation={orientation}
      variant={variant}
      views={views}
      autoOk={autoOk}
      clearable={clearable}
      disableFuture={disableFuture}
      disablePast={disablePast}
      disableToolbar={disableToolbar}
      disabled={disabled}
      emptyLabel={emptyLabel}
      inputVariant={inputVariant}
      keyboardIcon={<Time />}
      TextFieldComponent={TextFieldComponent}
    />
  );
};

TimePickerMUI.propTypes = {
  autoOk: PropTypes.bool,
  className: PropTypes.string,
  clearable: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  disableToolbar: PropTypes.bool,
  disabled: PropTypes.bool,
  emptyLabel: PropTypes.string,
  format: PropTypes.string,
  inputVariant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  label: PropTypes.string,
  maxDate: PropTypes.any,
  maxDateMessage: PropTypes.string,
  minDate: PropTypes.any,
  minDateMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  openTo: PropTypes.oneOf(['date', 'year', 'month']),
  orientation: PropTypes.oneOf(['portrait', 'landscape']),
  readOnly: PropTypes.bool,
  value: PropTypes.any,
  variant: PropTypes.oneOf(['dialog', 'inline', 'static']),
  views: PropTypes.arrayOf(PropTypes.string)
};

export default TimePickerMUI;
